define('CustomProductCollection.FacetHelper', [
    'underscore'
], function CustomProductCollectionFacetHelper(
    _
) {
    'use strict';

    /**
     * Utility functions for managing facet/exclude logic and master facet setup
     * in custom product collection modules.
     * Depends on underscore for array iteration.
     * @module CustomProductCollection.FacetHelper
     */

    /**
     * Updates the search master options to properly exclude the child item facet.
     * @param {Object} searchApiMasterOptions
     * @returns {Object}
     */
    function defineSearchMasterOptions(searchApiMasterOptions) {
        var facetsToExclude;

        facetsToExclude = searchApiMasterOptions['facet.exclude'] || '';
        facetsToExclude = facetsToExclude ? facetsToExclude.split(',') : [];
        facetsToExclude.push('custitem_cpc_is_child_item');
        searchApiMasterOptions['facet.exclude'] = facetsToExclude.join(',');

        searchApiMasterOptions.custitem_cpc_is_child_item = 'F';

        return searchApiMasterOptions;
    }

    /**
     * Sets up master facet logic for various environment locations.
     * @param {Object} environmentComponent
     */
    function setupMasterFacet(environmentComponent) {
        var masterFacetPlaces = ['Facets', 'merchandisingZone', 'typeAhead', 'itemsSearcher'];

        _(masterFacetPlaces).each(function forEachMasterFacetPlace(masterFacetPlace) {
            environmentComponent.defineSearchMasterOptions(
                masterFacetPlace,
                defineSearchMasterOptions
            );
        });
    }

    /**
     * @returns {Object} Utility API for facet helper logic.
     */
    return {
        defineSearchMasterOptions: defineSearchMasterOptions,
        setupMasterFacet: setupMasterFacet
    };
});
